module.exports = __webpack_public_path__ + "static/media/icon-notification-white.5db0b006.svg";